import React, {Fragment, useMemo} from "react";
import PropTypes from "prop-types";
import {UncontrolledTooltip} from "reactstrap";
import {FaQuestionCircle} from "react-icons/fa";
import slugify from "slugify";

/** This component will display help icon.
 *  And tooltip with help text when hovered on help icon */
/* eslint-disable react-hooks/purity */

const HelpIcon = (props) => {
  const {target, text} = props;
  const customId = useMemo(() => {
    const slug = slugify(target, {lower: true, strict: true});
    return `${slug}-${Math.floor(Math.random() * 100)}`;
  }, [target]);
  return (
    <Fragment>
      <FaQuestionCircle data-cy="help-icon" id={customId} className="float-right" />
      <UncontrolledTooltip
        target={customId}
        placement={"auto"}
        style={{maxWidth: "250px"}}
      >
        {Array.isArray(text) ? (
          <div style={{textAlign: "left"}}>
            {text.map((line, index) => (
              <div key={index}>• {line}</div>
            ))}
          </div>
        ) : (
          text
        )}
      </UncontrolledTooltip>
    </Fragment>
  );
};

HelpIcon.propTypes = {
  /** Text to be displayed in tooltip */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
    .isRequired,
  /** id which will be used by ReactTooltip component */
  target: PropTypes.string.isRequired,
};

export default HelpIcon;
